export default __webpack_public_path__ + "media/images/short-arrow-a7f6964e653eebf3ab0e26d1f3963c1f.svg";